.section {
  padding-top: calc(88px * 0.7);
  padding-bottom: calc(88px * 0.7);
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.card {
  padding: 28px 24px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-bg-card);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.card:hover {
  border-color: var(--color-border-strong);
  box-shadow: var(--shadow-glow);
}

.cardTitle {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
}

.cardText {
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .section {
    padding-top: calc(64px * 0.7);
    padding-bottom: calc(64px * 0.7);
  }
}
